import React, { useEffect, useRef, useContext } from 'react';

/** @jsx jsx */
import { css, jsx } from '@emotion/core';

import { TagIcon, styles } from '@tag/tag-components-react-v3';
import { clearChildNodes } from './RunningCodeUtils';
import { darkModeContext } from '../darkModeContext';

type Props = {
  htmlEvents?: string[];
};
export const RunningCodeEventsRaised = (props: Props) => {
  const htmlEventsElement = useRef<HTMLDivElement>(null);

  const docsDarkMode = useContext(darkModeContext);
  const docsDarkModeValue = docsDarkMode.value || false;

  useEffect(() => {
    const htmlEventsElementRef = htmlEventsElement.current;

    if (htmlEventsElementRef) {
      clearChildNodes(htmlEventsElementRef);
    }

    return () => {
      if (htmlEventsElementRef) {
        clearChildNodes(htmlEventsElementRef);
      }
    };
  }, [props.htmlEvents]);

  return (
    <React.Fragment>
      <div
        css={css`
          margin: 20px 0px;
          display: none;
          align-items: center;
        `}
        className="code-preview-html-events-raised-title"
      >
        <span
          css={css`
            font-size: 14px;
            font-weight: bold;
          `}
        >
          Events raised
        </span>
        <button
          css={css`
            border: 0;
            background-color: transparent;
            cursor: pointer;
            :focus {
              outline: none;
            }
          `}
        >
          <TagIcon icon="Delete" colourScheme={docsDarkModeValue ? 'dark' : 'light'} />
        </button>
      </div>

      <div
        ref={htmlEventsElement}
        className="code-preview-html-events-raised"
        css={css`
          max-height: 150px;
          overflow-y: auto;
          -webkit-overflow-scrolling: touch;
          background-color: ${docsDarkModeValue ? undefined : '#f7fafc'};
          border: 1px solid ${styles.colours.border};
          border-radius: 3px;
          padding: 8px 15px;
          display: none;
        `}
      ></div>
    </React.Fragment>
  );
};
